import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages, useIntl } from 'react-intl'
import Link from 'components/Link'

const messages = defineMessages({
  contactUs: {
    id: 'ContactUsLink.contactUs',
    defaultMessage: 'Contact Us'
  }
})

export default function ContactUsLink ({
  children,
  ...props
}) {
  const intl = useIntl()
  return (
    <Link
      to={ROUTE_PATH.CONTACT}
      style={{
        color: STYLES_COLOR.BLUE
      }}
      {...props}
    >
      {children || formatMessageIntlUtil(
        intl,
        messages.contactUs
      )}
    </Link>
  )
}
